"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toValidHEX = toValidHEX;

/**
 * Converts the value to a valid HEX color.
 * @param value Converted value.
 */
function toValidHEX(value) {
  if (!value.startsWith("#") || value.length === 4) {
    var ctx = document.createElement("canvas").getContext("2d");

    if (!ctx) {
      throw new Error("2d context not supported or canvas already initialized");
    }

    ctx.fillStyle = value;
    return ctx.fillStyle;
  } else if (value.length === 7) {
    return value;
  } else {
    return "#000000";
  }
}